module.exports = __webpack_public_path__ + "static/img/81123D_1_2_R_20220725_fit.6ead490.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/81123D_1_2_R_20220725_fit.png
// module id = 3pTW
// module chunks = 0